import { gsap } from "gsap";

const SHIMMER_STAR_LOOP_PAUSE_MS = 5000;

export default class ResultsHeader {
	constructor(block) {
		this.block = block;
		this.chevronGraphic = this.block.querySelector(".chevron-graphic");
		this.backLink = this.block.querySelector(".back-link");
		this.title = this.block.querySelector(".block-title");
		this.shimmerStars = this.block.querySelectorAll(".btn-shimmer-star");

		this.setStartingPositions();
		this.animateIn();
		this.initShimmerStarLoopPause();
	}

	setStartingPositions() {
		gsap.set(this.chevronGraphic, {
			x: '-90vw'
		});
		gsap.set(this.backLink, {
			opacity: 0
		});
		gsap.set(this.title, {
			opacity: 0
		});
	}

	animateIn() {
		const tl = gsap.timeline();
		tl.to(this.chevronGraphic, {
			x: 0,
			duration: 1,
			ease: "power2.out",
			delay: 1
		});
		tl.to(this.title, {
			opacity: 1,
			duration: 0.5,
			ease: "power2.out"
		}, '>-0.5');
		tl.to(this.backLink, {
			opacity: 1,
			duration: 0.5,
			ease: "power2.out",
		}, '>-0.25');
	}

	initShimmerStarLoopPause() {
		if (!this.shimmerStars.length) {
			return;
		}

		this.shimmerStars.forEach((star) => {
			star.addEventListener("animationiteration", () => {
				star.style.animationPlayState = "paused";
				window.setTimeout(() => {
					if (document.querySelector(".results-page.loaded")) {
						star.style.animationPlayState = "running";
					}
				}, SHIMMER_STAR_LOOP_PAUSE_MS);
			});
		});
	}
}
